import { SEOHead } from "components/SEO"
import { SIGNUP_URL } from "constants/urls"
import NewsletterSection from "components/Blocks/NewsletterSection"
import CommitmentsSection from "components/pages/about/CommitmentsSection"
import HistorySection from "components/pages/about/HistorySection"
import InvestorsSection from "components/pages/about/InvestorsSection"
import NewsSection from "components/pages/about/NewsSection"
// import TilesSection from "components/pages/about/TilesSection"
import Layout from "components/ui/Layout"

function AboutPage({ location: { pathname } }) {
  return (
    <Layout
      headerFloating
      trackingName="About Us"
      pageName="about"
      pagePath={pathname}
    >
      <HistorySection />
      <CommitmentsSection />
      <InvestorsSection />
      <NewsSection />
      {/* <TilesSection /> */}
      <NewsletterSection
        heading="Let’s get visual. Try Preset today."
        darkTheme
        ctaButton={{
          buttonLabel: "Start for free",
          trackingName: "Start for free (footer)_About us",
          url: SIGNUP_URL,
          color: "white",
          roundedCorner: true,
        }}
      />
    </Layout>
  )
}

// Export a Head component for Gatsby Head API
export function Head() {
  return (
    <SEOHead
      title="About Us"
      description="Founded by the original creator of Apache Superset™, Preset is committed to making data science, data engineering and deep analytics much more accessible."
    />
  )
}

export default AboutPage
